export const AUTH_USER_REQUEST = 'AUTH_USER_REQUEST';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_FAILURE = 'AUTH_USER_FAILURE';

export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILURE = 'REGISTER_USER_FAILURE';

export const RESET_AUTH_STATE = 'RESET_AUTH_STATE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const SET_NEWPASSWORD_REQUEST = 'SET_NEWPASSWORD_REQUEST';
export const SET_NEWPASSWORD_SUCCESS = 'SET_NEWPASSWORD_SUCCESS';
export const SET_NEWPASSWORD_FAILURE = 'SET_NEWPASSWORD_FAILURE';

export const SEND_MFA_CODE_REQUEST = 'SEND_MFA_CODE_REQUEST';
export const SEND_MFA_CODE_SUCCESS = 'SEND_MFA_CODE_SUCCESS';
export const SEND_MFA_CODE_FAILURE = 'SEND_MFA_CODE_FAILURE';

export const SEND_OTP_CODE_REQUEST = 'SEND_OTP_CODE_REQUEST';
export const SEND_OTP_CODE_SUCCESS = 'SEND_OTP_CODE_SUCCESS';
export const SEND_OTP_CODE_FAILURE = 'SEND_OTP_CODE_FAILURE';

export const VERIFY_OTP_REQUEST = 'VERIFY_OTP_REQUEST';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';
